import PropTypes from "prop-types";

export const MenuItemModel = {
    id: PropTypes.string.isRequired,
    display: PropTypes.string.isRequired,
    path: PropTypes.string,
    componentToRender: PropTypes.func,
    exact: PropTypes.bool,
    selected: PropTypes.bool,
    showIndicator: PropTypes.bool
};

export const TopLevelMenuItemModel = {
    ...MenuItemModel,
        menus: PropTypes.arrayOf(PropTypes.shape(MenuItemModel)),
        expanded: PropTypes.bool

};
